import { CREATE_CHAT_SESSION_MUTATION } from './GraphQlQuery/ChatGraphqlQueries';
import type { ChatSessionResult, CreateChatSessionInput } from './Type/ChatTypes';
import { pokerGraphqlRequest } from '../Utils/PokerGraphqlClient';

export const createChatSession = async (args: {
  input?: CreateChatSessionInput;
  signal?: AbortSignal;
}): Promise<ChatSessionResult> => {
  const res = await pokerGraphqlRequest<
    { createChatSession: ChatSessionResult },
    { input?: CreateChatSessionInput }
  >({
    query: CREATE_CHAT_SESSION_MUTATION,
    variables: args.input ? { input: args.input } : undefined,
    signal: args.signal,
  });

  return res.createChatSession;
};
